import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Inject,
  Input,
  OnInit,
} from '@angular/core'
import { ClassInitService } from '../../../../core/services/class-init.service'
import { LayoutConfigService } from '../../../../core/services/layout-config.service'
import * as objectPath from 'object-path'
import { DOCUMENT } from '@angular/common'
import { PrivateLabelService } from '../../../pages/showroom/private-label.service'
import { Observable } from 'rxjs'
import { ShowroomService } from '../../../../services/showroom/showroom.service'
import { TokenService } from '../../../../services/token.service'
import { Showroom } from '../../../../models/showroom/showroom'

@Component({
  selector: 'm-brand',
  templateUrl: './brand.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandComponent implements OnInit {
  @HostBinding('class') classes = 'm-stack__item m-brand'
  @Input() menuAsideLeftSkin: any = ''
  @Input() menuAsideMinimizeDefault: any = false
  @Input() menuAsideMinimizToggle: any = false
  @Input() menuAsideDisplay: any = false
  @Input() menuHeaderDisplay: any = true
  @Input() headerLogo: any = 'assets/app/media/img/misc/kitchendev.png'

  company: any = {
    name: '',
    location: {
      name: null,
    },
  }

  constructor(
    private classInitService: ClassInitService,
    private layoutConfigService: LayoutConfigService,
    private privateLabelService: PrivateLabelService,
    private showroomService: ShowroomService,
    private tokenService: TokenService,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document
  ) {
    // subscribe to class update event
    this.classInitService.onClassesUpdated$.subscribe((classes) => {
      this.classes = 'm-stack__item m-brand ' + classes.brand.join(' ')
    })

    this.layoutConfigService.onLayoutConfigUpdated$.subscribe((model) => {
      this.menuAsideLeftSkin = objectPath.get(model, 'config.aside.left.skin')

      this.menuAsideMinimizeDefault = objectPath.get(
        model,
        'config.aside.left.minimize.default'
      )

      this.menuAsideMinimizToggle = objectPath.get(
        model,
        'config.aside.left.minimize.toggle'
      )

      this.menuAsideDisplay = objectPath.get(model, 'config.menu.aside.display')

      this.menuHeaderDisplay = objectPath.get(
        model,
        'config.menu.header.display'
      )

      const headerLogo = objectPath.get(model, 'config.header.self.logo')
      if (typeof headerLogo === 'object') {
        this.headerLogo = objectPath.get(headerLogo, this.menuAsideLeftSkin)
      } else {
        this.headerLogo = headerLogo
      }
    })
  }

  public get isPrivateLabel$(): Observable<boolean> {
    return this.privateLabelService.isPrivateLabel$
  }

  public get isVendor() {
    return this.tokenService.user.vendor_id !== null
  }

  ngOnInit(): void {
    if (
      this.tokenService.user.role == 'sales' ||
      this.tokenService.user.role == 'showroom_admin'
    ) {
      this.setShowroomName()
    } else if (this.tokenService.user.role == 'superadmin') {
      this.company.name = 'Persist Digital'
      this.cdr.detectChanges()
    } else if (this.tokenService.user.vendor) {
      this.company.name = this.tokenService.user.vendor.name
      this.cdr.detectChanges()
    }
  }

  public logoURL() {
    if (this.isVendor) {
      return 'vendor/dashboard/quick-access'
    } else {
      return 'showroom/dashboard'
    }
  }

  /**
   * If user belongs to a showroom we'll get showroom name and set it on the header.
   */
  private setShowroomName() {
    this.showroomService.getShowroomInfo().subscribe(
      (showroom: Showroom) => {
        this.company = showroom
        this.cdr.detectChanges()
      },
      (error) => {
        console.log(error)
      }
    )
  }

  /**
   * Toggle class topbar show/hide
   * @param event
   */
  clickTopbarToggle(event: Event): void {
    this.document.body.classList.toggle('m-topbar--on')
  }
}
